/**
 * Преобразование текста между русской и английской раскладками клавиатуры.
 * Нужно для поиска в палитре команд (Ctrl+K / Cmd+K): «nfhbas» → «тарифы».
 */

/** Физическое соответствие клавиш: английская буква → русская. */
const EN_TO_RU_LAYOUT: Record<string, string> = {
  q: 'й',
  w: 'ц',
  e: 'у',
  r: 'к',
  t: 'е',
  y: 'н',
  u: 'г',
  i: 'ш',
  o: 'щ',
  p: 'з',
  '[': 'х',
  ']': 'ъ',
  a: 'ф',
  s: 'ы',
  d: 'в',
  f: 'а',
  g: 'п',
  h: 'р',
  j: 'о',
  k: 'л',
  l: 'д',
  ';': 'ж',
  "'": 'э',
  z: 'я',
  x: 'ч',
  c: 'с',
  v: 'м',
  b: 'и',
  n: 'т',
  m: 'ь',
  ',': 'б',
  '.': 'ю',
  '/': '.',
  '`': 'ё'
};

const RU_TO_EN_LAYOUT: Record<string, string> = Object.fromEntries(
  Object.entries(EN_TO_RU_LAYOUT).map(([en, ru]) => [ru, en])
);

function convertLayout(text: string, map: Record<string, string>): string {
  let out = '';
  for (const char of text) {
    const lower = char.toLowerCase();
    const mapped = map[lower];
    if (!mapped) {
      out += char;
      continue;
    }
    out += char === lower ? mapped : mapped.toUpperCase();
  }
  return out;
}

export function toRussianLayout(text: string): string {
  return convertLayout(text, EN_TO_RU_LAYOUT);
}

export function toEnglishLayout(text: string): string {
  return convertLayout(text, RU_TO_EN_LAYOUT);
}

/** Варианты запроса для поиска: исходный и в обеих раскладках, без дублей. */
export function keyboardLayoutSearchVariants(text: string): string[] {
  return Array.from(new Set([text, toRussianLayout(text), toEnglishLayout(text)]));
}
